module.exports = __webpack_public_path__ + "img/joel-crosby@2x.b670e0b8.jpg";